import React from 'react';
import '../../styles/kyro-design.css';

const Disclaimer: React.FC = () => {
  return (
    <div className="page">
      <div className="login-hero-min">
        <div className="hero-grid" />
        <div className="hero-glow" />
        <div className="hero-inner" style={{ textAlign: 'center', maxWidth: 'none' }}>
          <h1 style={{ fontSize: 'clamp(1.8rem, 3vw, 2.4rem)' }}>Disclaimer</h1>
          <p className="hero-sub" style={{ margin: '0.5rem 0 0', opacity: 0.7 }}>Last Updated: March 2, 2026</p>
        </div>
      </div>

      <div className="legal-content-min">
            <div style={{ background: 'var(--blue-lt)', padding: '1rem', border: '1px solid rgba(68,114,196,0.2)', marginBottom: '1.5rem' }}>
              <h3>Important Notice</h3>
              <p>
                <strong>PLEASE READ THIS DISCLAIMER CAREFULLY BEFORE USING THIS WEBSITE OR CONSIDERING 
                ANY INVESTMENT WITH KYRO ASSET MANAGEMENT.</strong>
              </p>
              <p>
                The information contained on this website is for general informational purposes only 
                and does not constitute an offer to sell or a solicitation to buy any securities or 
                investment products.
              </p>
            </div>

            <div>
              <h2>1. General Disclaimer</h2>
              <p>
                This website is maintained by Kyro Asset Management ("we," "us," or "our"). The content 
                provided is for informational purposes only and should not be construed as investment 
                advice, financial advice, legal advice, tax advice, or any other form of professional 
                advice.
              </p>
              <p>
                Nothing on this website constitutes a recommendation or endorsement of any particular 
                investment, security, transaction, or investment strategy. You should consult with 
                qualified professionals before making any investment decisions.
              </p>
            </div>

            <div>
              <h2>2. Investment Risks</h2>

              <h3>2.1 Market Risks</h3>
              <p>
                All investments carry risk, including the potential loss of principal. The value of 
                investments may fluctuate due to market conditions, economic factors, political events, 
                and other variables beyond our control.
              </p>

              <h3>2.2 No Guarantee of Returns</h3>
              <p>
                Past performance is not indicative of future results. We do not guarantee any specific 
                returns, capital preservation, or investment outcomes. Historical performance data, if 
                presented, should not be relied upon as a prediction of future performance.
              </p>

              <h3>2.3 Illiquidity Risk</h3>
              <p>
                Investments in Alternative Investment Funds (AIFs) are typically illiquid and subject 
                to lock-in periods. You may not be able to redeem your investment when desired, and 
                early redemption may result in penalties or losses.
              </p>

              <h3>2.4 Concentration Risk</h3>
              <p>
                The Fund may invest in a concentrated portfolio, which may result in higher volatility 
                and risk compared to more diversified investments.
              </p>

              <h3>2.5 Regulatory Risk</h3>
              <p>
                Changes in laws, regulations, or government policies may adversely affect the Fund's 
                operations, investment strategy, or returns.
              </p>

              <h3>2.6 Other Risks</h3>
              <p>
                Additional risks include but are not limited to: credit risk, interest rate risk, 
                currency risk, counterparty risk, operational risk, and force majeure events.
              </p>
            </div>

            <div>
              <h2>3. Regulatory Status</h2>

              <h3>3.1 SEBI Registration</h3>
              <p>
                Kyro Asset Management acts as the Investment Manager to a SEBI-registered
                Alternative Investment Fund (Category II), bearing SEBI Registration No. IN/AIF2/26-27/2191.
              </p>

              <h3>3.2 Not a Public Offering</h3>
              <p>
                The Fund is not a public offering and is intended only for eligible investors as 
                defined by SEBI regulations. Investment in the Fund is restricted to:
              </p>
              <ul>
                <li>High Net Worth Individuals (HNIs)</li>
                <li>Ultra High Net Worth Individuals (UHNIs)</li>
                <li>Family Offices</li>
                <li>Institutional Investors</li>
                <li>Other qualified investors meeting SEBI's eligibility criteria</li>
              </ul>

              <h3>3.3 Minimum Investment</h3>
              <p>
                The minimum investment amount is as prescribed by SEBI for Category II AIFs (currently 
                ₹1 crore or as amended from time to time).
              </p>
            </div>

            <div>
              <h2>4. Information Accuracy</h2>

              <h3>4.1 No Warranty</h3>
              <p>
                While we strive to provide accurate and up-to-date information, we make no 
                representations or warranties regarding the completeness, accuracy, reliability, 
                or timeliness of any content on this website.
              </p>

              <h3>4.2 Subject to Change</h3>
              <p>
                Information on this website may be updated, modified, or removed at any time without 
                notice. We are not obligated to update information or notify users of changes.
              </p>

              <h3>4.3 Third-Party Information</h3>
              <p>
                Some information may be obtained from third-party sources believed to be reliable. 
                However, we have not independently verified such information and make no representations 
                regarding its accuracy.
              </p>
            </div>

            <div>
              <h2>5. Forward-Looking Statements</h2>
              <p>
                This website may contain forward-looking statements regarding future events, 
                performance, strategies, or expectations. Such statements are based on current 
                assumptions and beliefs and are subject to significant risks and uncertainties.
              </p>
              <p>
                Actual results may differ materially from those expressed or implied in forward-looking 
                statements due to various factors including but not limited to:
              </p>
              <ul>
                <li>Changes in market conditions</li>
                <li>Economic and political developments</li>
                <li>Regulatory changes</li>
                <li>Competitive pressures</li>
                <li>Operational challenges</li>
                <li>Other unforeseen circumstances</li>
              </ul>
              <p>
                We undertake no obligation to update or revise forward-looking statements to reflect 
                actual results or changes in assumptions.
              </p>
            </div>

            <div>
              <h2>6. No Offer or Solicitation</h2>
              <p>
                Nothing on this website constitutes an offer to sell, or a solicitation of an offer 
                to buy, any securities or investment products in any jurisdiction where such offer or 
                solicitation would be unlawful.
              </p>
              <p>
                The Fund is intended for distribution only to eligible investors in jurisdictions where 
                such distribution is permitted. It is your responsibility to ensure compliance with 
                applicable laws in your jurisdiction.
              </p>
              <p>
                Any investment in the Fund shall be made solely on the basis of the Private Placement 
                Memorandum (PPM) and other offering documents, which contain detailed information about 
                risks, fees, terms, and conditions.
              </p>
            </div>

            <div>
              <h2>7. Tax Implications</h2>
              <p>
                Investment in the Fund may have tax implications depending on your individual 
                circumstances and jurisdiction. Tax laws are subject to change and may vary based 
                on your residency, income level, and other factors.
              </p>
              <p>
                We do not provide tax advice. You should consult with qualified tax advisors regarding 
                the tax consequences of investing in the Fund before making any investment decisions.
              </p>
            </div>

            <div>
              <h2>8. Suitability</h2>
              <p>
                Investment in Alternative Investment Funds is suitable only for sophisticated investors 
                who:
              </p>
              <ul>
                <li>Meet the eligibility criteria prescribed by SEBI</li>
                <li>Have sufficient financial resources to bear investment losses</li>
                <li>Understand the risks associated with alternative investments</li>
                <li>Have a long-term investment horizon</li>
                <li>Do not require liquidity from their investment</li>
                <li>Can afford to lose their entire investment</li>
              </ul>
              <p>
                You should carefully evaluate whether an investment in the Fund is suitable for you 
                based on your financial situation, investment objectives, risk tolerance, and liquidity 
                needs.
              </p>
            </div>

            <div>
              <h2>9. Third-Party Websites</h2>
              <p>
                This website may contain links to third-party websites for your convenience. We do not 
                endorse, control, or assume responsibility for the content, privacy policies, or 
                practices of any third-party websites.
              </p>
              <p>
                Access to third-party websites is at your own risk. We recommend reviewing the terms 
                and privacy policies of any third-party websites you visit.
              </p>
            </div>

            <div>
              <h2>10. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, Kyro Asset Management, its affiliates, 
                officers, directors, employees, and agents shall not be liable for any:
              </p>
              <ul>
                <li>Direct, indirect, incidental, special, consequential, or punitive damages</li>
                <li>Loss of profits, revenue, data, or business opportunities</li>
                <li>Investment losses or poor investment performance</li>
                <li>Errors, omissions, or inaccuracies in website content</li>
                <li>Unauthorized access to or use of our systems</li>
                <li>Interruption or cessation of website availability</li>
              </ul>
              <p>
                This limitation applies regardless of the legal theory (contract, tort, negligence, 
                strict liability, or otherwise) and whether or not we have been advised of the 
                possibility of such damages.
              </p>
            </div>

            <div>
              <h2>11. Confidentiality</h2>
              <p>
                Any confidential information provided to you regarding the Fund, investment strategies, 
                portfolio holdings, or our business operations must be kept strictly confidential and 
                not disclosed to third parties without our prior written consent.
              </p>
              <p>
                Unauthorized disclosure of confidential information may result in legal action and 
                termination of your relationship with us.
              </p>
            </div>

            <div>
              <h2>12. Governing Law</h2>
              <p>
                This Disclaimer shall be governed by and construed in accordance with the laws of 
                India. Any disputes arising from this Disclaimer or your use of this website shall 
                be subject to the exclusive jurisdiction of courts in [City], India.
              </p>
            </div>

            <div>
              <h2>13. Contact Information</h2>
              <p>
                If you have any questions about this Disclaimer, please contact us:
              </p>
              <div style={{ background: 'var(--off)', padding: '1rem', border: '1px solid var(--gray-lt)', marginTop: '1rem' }}>
                <p><strong>Kyro Asset Management</strong></p>
                <p>Email: <a href="mailto:compliance@kyrocapital.in">compliance@kyrocapital.in</a></p>
                <p>Phone: +91 76 111 111 02</p>
                <p>Address: 303, Unity One, Rajiv Gandhi Square, Indore – 452001</p>
              </div>
            </div>

            <div style={{ marginTop: '2rem', paddingTop: '1rem', borderTop: '1px solid var(--gray-lt)' }}>
              <p>
                <strong>By accessing or using this website, you acknowledge that you have read, 
                understood, and agree to this Disclaimer. If you do not agree, please discontinue 
                use of this website immediately.</strong>
              </p>
            </div>

            <div style={{ background: 'var(--blue-lt)', padding: '1rem', border: '1px solid rgba(68,114,196,0.2)', marginTop: '1rem' }}>
              <h3>Risk Warning</h3>
              <p>
                <strong>INVESTMENTS IN ALTERNATIVE INVESTMENT FUNDS INVOLVE SUBSTANTIAL RISK AND ARE 
                SUITABLE ONLY FOR SOPHISTICATED INVESTORS WHO CAN AFFORD TO LOSE THEIR ENTIRE INVESTMENT.</strong>
              </p>
              <p>
                Before investing, carefully review all offering documents and consult with qualified 
                financial, legal, and tax advisors.
              </p>
            </div>
      </div>
    </div>
  );
};

export default Disclaimer;
